module.exports = __webpack_public_path__ + "static/media/2pic.812cdc30.png";